import DateTimeBase from "./date_time_base_controller";

// Connects to data-controller="discount-sales-timing"
// Mirrors ticket-sales-timing: a dropdown picks when the discount is active and
// shows/hides the relevant start/end date+time fields.
export default class extends DateTimeBase {
  static targets = ["startDateField", "startTimeField", "endDateField", "endTimeField", 'startTimeWrapper',
    "endTimeWrapper", 'salesTimingSelect']

  connect() {
    // Set initial state based on the selected value
    this.handleTimingChange({ target: this.element })
  }

  handleTimingChange(event) {
    switch (this.salesTimingSelectTarget.value) {
      case 'always_active':
        this.hideAllFields()
        this.clearAllFields()
        break
      case 'scheduled_period':
        this.showAllFields()
        break
      case 'start_date_only':
        this.showStartFields()
        this.hideEndFields()
        this.clearEndFields()
        break
      case 'end_date_only':
        this.hideStartFields()
        this.showEndFields()
        this.clearStartFields()
        break
    }
  }

  hideAllFields() {
    this.startTimeWrapperTarget.classList.add('d-none')
    this.endTimeWrapperTarget.classList.add('d-none')
  }

  showAllFields() {
    this.startTimeWrapperTarget.classList.remove('d-none')
    this.endTimeWrapperTarget.classList.remove('d-none')
  }

  showStartFields() {
    this.startTimeWrapperTarget.classList.remove('d-none')
  }

  hideStartFields() {
    this.startTimeWrapperTarget.classList.add('d-none')
  }

  showEndFields() {
    this.endTimeWrapperTarget.classList.remove('d-none')
  }

  hideEndFields() {
    this.endTimeWrapperTarget.classList.add('d-none')
  }

  clearStartFields() {
    this.startDateFieldTarget.value = ''
    if (this.startDateFieldTarget.nextElementSibling) this.startDateFieldTarget.nextElementSibling.value = ''
    this.startTimeFieldTarget.value = ''
  }

  clearEndFields() {
    this.endDateFieldTarget.value = ''
    if (this.endDateFieldTarget.nextElementSibling) this.endDateFieldTarget.nextElementSibling.value = ''
    this.endTimeFieldTarget.value = ''
  }

  clearAllFields() {
    this.clearStartFields()
    this.clearEndFields()
  }
}
